import axios from "axios";

export async function submitFormData(formData) {
    try {
        const response = await axios.post(
            'https://api.impactrun.com/web/v1/work_with_us/create',
            formData,
            {
                headers: {
                    'Authorization': 'zajdbjhbshdbckmewiyuityfnncjcmcskllkmsdjkbhdvbwgv',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data.errors;
    }
}